import { ReactNode } from 'react';

import { appBorders, appColors } from '@backrs_ui/common-ui';

import { SxProps, Theme, Box } from '@mui/material';

type ImageTextBoxProps = Readonly<{
  imageSrc?: string;
  imageHeight?: number;
  body: ReactNode[];
  id?: string;
}>;

export const ImageTextBox = ({ body, imageSrc, imageHeight = 61, id }: ImageTextBoxProps) => {
  return (
    <Box sx={headerContainerStyle} id={id}>
      {imageSrc && <Box component="img" src={imageSrc} height={imageHeight} draggable={false} />}
      <Box sx={bodyContainerStyle}>
        {body.map((text: ReactNode, index: number) => (
          <Box key={index}>{text}</Box>
        ))}
      </Box>
    </Box>
  );
};

const headerContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: appColors.neutral.white,
  borderRadius: 2,
  ...appBorders.backrsDropShadowBorders.black,
  padding: { xs: '4px 8px', sm: '16px 32px' },
  position: 'relative',
  maxWidth: '30vw',
  '@media (max-width: 1204px)': {
    maxWidth: '50vw',
  },
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
  },
  '@media (max-height: 705px)': {
    maxWidth: '70vw',
    padding: '2px 4px',
  },
};

const bodyContainerStyle: SxProps<Theme> = {
  padding: {
    xs: 1,
    sm: 2,
  },
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};
